<template>
    <p class="form-text text-muted" v-if="user">
        <small>
            <span v-if="user.phone_mobile">
                Mobile:
                <a :href="`tel:${user.phone_mobile}`">
                    {{ user.phone_mobile }}
                </a><br>
            </span>
            <span v-if="user.phone_office">
                Office:
                <a :href="`tel:${user.phone_office}`">
                    {{ user.phone_office }}
                </a><br>
            </span>
            <span v-if="user.email">
                Email:
                <a :href="`mailto:${user.email}`">
                    {{ user.email }}
                </a>
            </span>
        </small>
    </p>
</template>

<script>
export default {
  props: ['user'],
};
</script>
